import { render, staticRenderFns } from "./lolth-file.vue?vue&type=template&id=08cf524a&scoped=true&"
import script from "./lolth-file.vue?vue&type=script&lang=ts&"
export * from "./lolth-file.vue?vue&type=script&lang=ts&"
import style0 from "./lolth-file.vue?vue&type=style&index=0&id=08cf524a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf524a",
  null
  
)

/* custom blocks */
import block0 from "./lolth-file.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports